import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '../TravelPlansRoyal/useStyles';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import TravelPlanCard from '../TravelPlanCard';
import { getCelebrityUrl } from '../../utils/common';
import { NAVIGATION_PATHS, ENABLE_HOTELS_CTA } from '../../utils/constants';

const TravelPlansCel = ({ isAuthenticated, ldFlags }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);

  const goToHotels = () => {
    const destinationUrl = isAuthenticated
      ? NAVIGATION_PATHS.celHotelsAuthenticated
      : NAVIGATION_PATHS.celHotels;
    window.location.href = destinationUrl;
  };
  const goToTransfers = () => {
    const destinationUrl = getCelebrityUrl(NAVIGATION_PATHS.timeline);
    window.location.href = destinationUrl;
  };
  const enableHotels = ldFlags?.[ENABLE_HOTELS_CTA];
  return (
    <section className={classes.TravelPlans}>
      <TravelPlanCard
        icon="transfers"
        cardTitle={getDictionary(Dictionary.airTravelPlansTransfersTitle.key)}
        cardInfo={getDictionary(Dictionary.airTravelPlansTransfersInfo.key)}
        ctaLabel={getDictionary(Dictionary.airTravelPlansTransfersCTA.key)}
        ctaOnClick={goToTransfers}
      />
      {enableHotels && (
        <TravelPlanCard
          icon="cel-hotels"
          cardTitle={getDictionary(Dictionary.airTravelPlansHotelsTitle.key)}
          cardInfo={getDictionary(Dictionary.airTravelPlansHotelsInfo.key)}
          ctaLabel={getDictionary(Dictionary.airTravelPlansHotelsCTA.key)}
          ctaOnClick={goToHotels}
        />
      )}
    </section>
  );
};
TravelPlansCel.propTypes = {
  isAuthenticated: PropTypes.bool,
};

export default TravelPlansCel;
